export * from './lib/authentication.service.module';

export { AccredibleAuthenticationApiService } from './lib/authentication.service';
